export const helpCenterArticleIds = {
  emailReminderSettings: '360057676512',
}
